module.exports = __webpack_public_path__ + "static/media/resume-v2.3929e3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resume-v2.png
// module id = 246
// module chunks = 0